module.exports = __webpack_public_path__ + "static/greydribble-bc3cbf89369c57f0edd21d7dde782081.png";